<template>
  <div id="projectDetails" v-if="divVisible">
    <b>プロジェクト情報詳細画面</b><br/><br/>

    <table>
      <tr>
        <td>プロジェクト情報詳細を参照いただきます。</td>
      </tr>
    </table><br/>

    <form onsubmit="return false;">
      <div align="right">
        <font v-for="(headPeriodYear, index0) in heads[0].periodYears" v-bind:key="'headPeriodYear' + index0">
          <a v-if="heads[0].headTitle.indexOf(headPeriodYear) == -1" hlef="#" @click="projectDetailsClick(headPeriodYear);">{{headPeriodYear}}年
          </a><b v-if="heads[0].headTitle.indexOf(headPeriodYear) != -1" >{{headPeriodYear}}年
        </b></font>
      </div>

      <div class="bootstrap-table fixed-table-container" style="margin-bottom:10px;margin-bottom:10px;width: 100%;">
        <table id="rptHeader0" class="table table-striped">
          <tbody>
            <tr>
              <td><b>プロジェクト名：</b></td>
              <td>{{ heads[0].projectInfo.projectName }}</td>
            </tr>
            <tr>
              <td><b>プロジェクト期間：</b></td>
              <td>{{ heads[0].projectInfo.startDate + " ～ " +  heads[0].projectInfo.endDate }}</td>
            </tr>
          </tbody>
        </table><br/><br/>

        <table id="rptHeader1" class="table table-striped">
          <thead>
            <tr>
              <td v-for="(head, index) in heads.slice(0, 6)" v-bind:key="'head' + index">
                {{ head.headTitle }}
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td v-for="(row, index) in rows.slice(0, 6)" v-bind:key="'row' + index">
                <b v-if="row.leaderInfos.length > 0">リーダー：</b>
                <div v-for="(rowLeaderInfo, index2) in row.leaderInfos" v-bind:key="'rowLeaderInfo' + index2">
                  <router-link :to="{ name: 'projectMemberManage', params: { backScreenId: $route.params.backScreenId, projectID: row.projectInfo.projectID, year: row.year, yearMonth: row.yearMonth, memberID: rowLeaderInfo.memberID } }">
                    {{ rowLeaderInfo.memberName }}
                  </router-link>
                </div>
                <b v-if="row.memberInfos.length > 0"><br/>メンバー：</b>
                <div v-for="(rowMemberInfo, index3) in row.memberInfos" v-bind:key="'rowMemberInfo' + index3">
                  <router-link :to="{ name: 'projectMemberManage', params: { backScreenId: $route.params.backScreenId, projectID: row.projectInfo.projectID, year: row.year, yearMonth: row.yearMonth, memberID: rowMemberInfo.memberID } }">
                    {{ rowMemberInfo.memberName }}
                  </router-link>
                </div>
                <b v-if="row.helperInfos.length > 0"><br/>ヘルパー：</b>
                <div v-for="(rowHelperInfo, index4) in row.helperInfos" v-bind:key="'rowHelperInfo' + index4">
                  <router-link :to="{ name: 'projectMemberManage', params: { backScreenId: $route.params.backScreenId, projectID: row.projectInfo.projectID, year: row.year, yearMonth: row.yearMonth, memberID: rowHelperInfo.memberID } }">
                    {{ rowHelperInfo.memberName }}
                  </router-link>
                </div>
              </td>
            </tr>
          </tbody>
        </table><br/>

        <table id="rptHeader2" class="table table-striped">
          <thead>
            <tr>
              <td v-for="(head, index) in heads.slice(6, 12)" v-bind:key="'head' + index">
                {{ head.headTitle }}
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td v-for="(row, index) in rows.slice(6, 12)" v-bind:key="'row' + index">
                <b v-if="row.leaderInfos.length > 0">リーダー：</b>
                <div v-for="(rowLeaderInfo, index2) in row.leaderInfos" v-bind:key="'rowLeaderInfo' + index2">
                  <router-link :to="{ name: 'projectMemberManage', params: { backScreenId: $route.params.backScreenId, projectID: row.projectInfo.projectID, year: row.year, yearMonth: row.yearMonth, memberID: rowLeaderInfo.memberID } }">
                    {{ rowLeaderInfo.memberName }}
                  </router-link>
                </div>
                <b v-if="row.memberInfos.length > 0"><br/>メンバー：</b>
                <div v-for="(rowMemberInfo, index3) in row.memberInfos" v-bind:key="'rowMemberInfo' + index3">
                  <router-link :to="{ name: 'projectMemberManage', params: { backScreenId: $route.params.backScreenId, projectID: row.projectInfo.projectID, year: row.year, yearMonth: row.yearMonth, memberID: rowMemberInfo.memberID } }">
                    {{ rowMemberInfo.memberName }}
                  </router-link>
                </div>
                <b v-if="row.helperInfos.length > 0"><br/>ヘルパー：</b>
                <div v-for="(rowHelperInfo, index4) in row.helperInfos" v-bind:key="'rowHelperInfo' + index4">
                  <router-link :to="{ name: 'projectMemberManage', params: { backScreenId: $route.params.backScreenId, projectID: row.projectInfo.projectID, year: row.year, yearMonth: row.yearMonth, memberID: rowHelperInfo.memberID } }">
                    {{ rowHelperInfo.memberName }}
                  </router-link>
                </div>
                <br/>
              </td>
            </tr>
          </tbody>
        </table>
      </div><br/>
      <button v-on:click="projectMemberManageClick" class="btn-mid" style="width:250px;">プロジェクト要員追加</button>&nbsp;
      <button v-if="$route.params.backScreenId == 'projects'" @click="$router.back(-1);" class="btn-mid" style="width:250px;">プロジェクト情報一覧画面へ</button><br/>
      <button v-if="$route.params.backScreenId == 'sales'" @click="$router.back(-1);" class="btn-mid" style="width:250px;">管理人月数情報一覧画面へ</button><br/>

     <!-- <button v-if="$route.params.backScreenId == 'projects'" @click="$router.push({ name: 'projects', params: { year: '' } });" class="btn-mid" style="width:250px;">プロジェクト情報一覧画面へ</button><br/>
      <button v-if="$route.params.backScreenId == 'sales'" @click="$router.push({ name: 'sales', params: { evaluateeMemberID: '', year: '' } });" class="btn-mid" style="width:250px;">管理人月数情報一覧画面へ</button><br/>
     -->
    </form>
  </div>
</template>

<script>
  export default {
    name: "projectDetails",
    data() {
      return {
          divVisible: false,
          user:  { memberID: '', memberName: '', userType: '', deleteFlg: '' },
          heads: [ { year: '', yearMonth: '', headTitle: '',
                     periodYears: [{ }],
                     projectInfo: { projectID: '', projectName: '', startDate: '', endDate: '' },
                     leaderInfos: [ { memberID: '', memberName: '' }, ],
                     memberInfos: [ { memberID: '', memberName: '' }, ],
                     helperInfos: [ { memberID: '', memberName: '' }, ] },
                 ],
          rows:  [ { year: '', yearMonth: '', headTitle: '',
                     periodYears: [{ }],
                     projectInfo: { projectID: '', projectName: '', startDate: '', endDate: '' },
                     leaderInfos: [ { memberID: '', memberName: '' }, ],
                     memberInfos: [ { memberID: '', memberName: '' }, ],
                     helperInfos: [ { memberID: '', memberName: '' }, ] },
                 ],
      }
    },
    mounted() {
      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.src = '/static/js/common.js?v=17';
      document.body.appendChild(s);
      this.init();
    },
    methods: {
      init: function () {
        var self = this;

        // サーバ側処理呼び出す
        new Promise(function (request, response) {
          var data = self.$route.params;
          common.getAxios().post(process.env.API_URL +"/api/ProjectDetailsInit", data)
            .then(function (res) {
              if (res.data) {
                self.user = res.data.user;
                self.heads = res.data.heads;
                self.rows = res.data.rows;

                self.divVisible = true;
              }
            })
            .catch(function (err) {
              alert(err);
            });
        });
      },
      projectMemberManageClick: function () {
        var self = this;
        self.$router.push({ name: 'projectMemberManage',
          params: { backScreenId: self.$route.params.backScreenId, projectID: self.heads[0].projectInfo.projectID, year: self.heads[0].year } });
      },
      projectDetailsClick: function (periodYear) {
        var self = this;
        self.$router.push({ name: 'projectDetails',
          params: { backScreenId: self.$route.params.backScreenId, year: periodYear, projectID: self.$route.params.projectID } });
        this.init();
      },
    }
  };
</script>



// WEBPACK FOOTER //
// projectDetails.vue?d0e7a6a0